<template>
    <div class="container">
        <b-modal :model-value="EditNiifNoContr" :no-close-on-backdrop="true" hide-header hide-footer centered>
            <div class="text-center">
                {{ labels.title }} 
            </div>
            <div>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.vigencia}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h5>
                            <select id="selVigencia" name="" v-model="selVigencia" class="form-control">
                                <option v-for="vigencia in listVigencia" :key="vigencia?.vigencia"> {{ vigencia?.vigencia }}</option>                             </select>
                        </h5>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="2"></b-col>
                    <b-col cols="4" class="text-left">
                        <h5>{{labels.niif}}</h5> 
                    </b-col>
                    <b-col cols="6" class="text-left">
                        <h5>
                            <select id="selNiif" name="" v-model="selNiif" class="form-control">
                                <option v-for="niif in listaNiif" :key="niif?.id"> {{ niif?.niif }}</option>                             </select>
                        </h5>
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <b-button class="md-primary" @click="guardaNiif" :disabled="isVigenciaBloqueada">{{ labels.save }}</b-button> 
                    <b-button class="md-accent" @click="closeModal">{{ labels.close }}</b-button> 
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import NiifNoControlante from '../../services/NiifNoControlante'; 
import PlanConsolidacion from '../../services/PlanConsolidacion'; 
export default {
    name: "EditaNiifNoControlante",
    props:['EditNiifNoContr','regNiif'],
    data: () => ({
        listVigencia : [],
        selVigencia : "",
        listaNiif : [],
        selNiif : "",
        selVigenciaAnterior: ""
    }),
    computed:{
        isVigenciaBloqueada(){
            return this.selVigencia ? !this.$store.getters.isPeriodoEnabled(this.selVigencia) : false
        },
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : "Editar NIIF",
                    vigencia : "Vigencia",
                    niif : "Niif",
                    save : "Guardar",
                    close : "Cerrar"
                }
            }else{
                return {
                    title : "Edita NIIF",
                    vigencia : "Validity",
                    niif : "Niif",
                    save : "Save",
                    close : "Close"
                }
            }
        }
    },
    methods:{
        guardaNiif(){
            // console.log('guardaNiif') 
            if (this.isVigenciaBloqueada) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar')
                return
            }
            if(this.selNiif == ""){
                this.$toast.error('Seleccionar un NIIF')
            }else{
                let infoData = {
                    "niif"      : this.selNiif,
                    "idNiif"    : this.regNiif,
                    "idUser"    : this.$store.state.userId
                }
                // console.log(infoData) 
                NiifNoControlante.updateNiifNoControlante(infoData) 
                .then((res) => { 
                    this.$toast.success(res.data.message)
                    location.reload() 
                })
                .catch((err) => err) 
            }
        },
        closeModal(){
            this.selVigencia = ""
            this.selNiif = ""
            this.$emit('closeModal',false)
        }
    },
    mounted(){
        PlanConsolidacion.getVigenciaPlanCons() 
        .then((res) => { 
            this.listVigencia = res.data.getVigencia
        })
        .catch((err) => console.log(err)) 
    },
    watch:{
        selVigencia(valNew){
            if (valNew !== this.selVigenciaAnterior) {
                this.selVigenciaAnterior = valNew
                if (this.isVigenciaBloqueada) {
                    this.listaNiif = []
                    this.selNiif = ""
                    this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar')
                    return
                }
            }
            PlanConsolidacion.getPlanConsPorCompVige(valNew) 
            .then((res) => { 
                this.listaNiif = res.data.planConsNiif
                // console.log(this.listaNiif)
            })
            .catch((err) => { 
                console.log(err) 
            })
        }
    }
}
</script>
<style>
</style>
